import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { DateSelect } from "../../../compnents/form/DateSelect"
import {
  CloseCircleOutlined,
  CloseOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons"
import { stringTrim } from "../../../utils/StringUtils"
import FileUpload from "../../../compnents/file/FileUpload"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import { DateTimeFormatSimple } from "../../../models/datetime"
import { GenderOptions, getGenderName } from "../../../models/user"
import axios from "axios"
import { selectCredentials, selectShortName, selectTenantName } from "../../../app/applicationSlice"
import moment from "moment"
import { acceptImgTypes, mapType, SUPPORTED_IMAGE_TYPES } from "../fileUploadService"

export const DoctorFormModal = (props: {
  visible: boolean
  token: string
  AXIOS_IP: string
  updateDoctor?: any
  editable?: any
  onOk: (v: any) => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const { TextArea } = Input

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const shortName = useSelector(selectShortName)

  const [fileZGUrl, setfileZGUrl] = useState<any>([]) //资格证

  const [fileZCUrl, setfileZCUrl] = useState<any>([]) //职称证书

  const [fileYSUrl, setfileYSUrl] = useState<any>([]) //医师执业证

  const [fileJGUrl, setfileJGUrl] = useState<any>([]) //机构审查意见

  const [types, setTypes] = useState<any>({})

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [isDoctorOverlayVisible, setIsDoctorOverlayVisible] = useState(false)

  const [keyword, setKeyword] = useState('')

  const [doctorList, setDoctorList] = useState<any>([])

  const [baseUrl, setBaseUrl] = useState("")

  const [baseType, setBaseType] = useState(true)

  const [isModalVisible, setIsModalVisible] = useState(false) //预览

  const getTypes = () => {
    axios({
      url: `${props.AXIOS_IP}/dic/getDicListByDicTypes`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
      data: {
        dicTypeList: [
          "personnel_type",
          "political_status",
          "education_level",
          "degree_type",
          "work_status",
          "practice_scope",
          "id_card_type",
          "multi_site_practice",
          "administrative_management",
          "practice_category",
        ],
      },
    }).then((res: any) => {
      const data: any = res.data.data
      setTypes({
        degreeType: mapType(data?.degree_type),
        educationLevel: mapType(data?.education_level),
        idCardType: mapType(data?.id_card_type),
        multiSitePractice: mapType(data?.multi_site_practice),
        practiceCategory: mapType(data?.practice_category),
        practiceScope: mapType(data?.practice_scope),
        politicalStatus: mapType(data?.political_status),
        personnelType: mapType(data?.personnel_type),
        administrativeManagement: mapType(data?.administrative_management),
        workStatus: mapType(data?.work_status),
      })
    })
  }

  // 处理图片上传前操作
  const beforeUpload = (file: File, urls: []) => {
    if (urls.length >= 3) {
      message.error("最多只能上传3张图片!")
      return Upload.LIST_IGNORE // 阻止上传
    }
    if (!SUPPORTED_IMAGE_TYPES.includes(file.type)) {
      message.error(`不支持的图片格式!`)
      return false
    }
    const isLt2M = file.size / 1024 / 1024 < 10
    if (!isLt2M) {
      message.error("图片大小必须小于 10MB!")
    }
    return isLt2M
  }

  // 处理文件上传前操作
  const beforeUploadFile = (file: File, urls: []) => {
    if (urls.length >= 3) {
      message.error("最多只能上传3个文件!")
      return Upload.LIST_IGNORE // 阻止上传
    }
    const isWord =
      file.type === "application/msword" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    const isPdf = file.type === "application/pdf"

    if (!isPdf) {
      message.error("仅支持PDF格式文件!")
      return false
    }
    const isLt2M = file.size / 1024 / 1024 < 10
    if (!isLt2M) {
      message.error("文件大小必须小于 10MB!")
    }
    return isLt2M
  }

  // 自定义上传实现
  const customRequest = async (
    { file, onSuccess, onError, onProgress }: any,
    type: string
  ) => {
    const formData = new FormData()
    formData.append("file", file)
    formData.append("name", file.name)
    try {
      // 使用axios发送请求
      const response = await axios.post(
        `${props.AXIOS_IP}/infra/file/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            onProgress({ percent })
          },
        }
      )
      if (response.data) {
        const data = response.data
        switch (type) {
          case "ZC":
            setfileZCUrl([
              ...fileZCUrl,
            { fileConfigId: data?.configId, fileName: data?.name, fileType: data?.type, filePath: data?.path },
            ])
            break
          case "ZG":
            setfileZGUrl([
              ...fileZGUrl,
              { fileConfigId: data?.configId, fileName: data?.name, fileType: data?.type, filePath: data?.path },
            ])
            break
          case "YS":
            setfileYSUrl([
              ...fileYSUrl,
              { fileConfigId: data?.configId, fileName: data?.name, fileType: data?.type, filePath: data?.path },
            ])
            break
          case "JG":
            setfileJGUrl([
              ...fileJGUrl,
              { fileConfigId: data?.configId, fileName: data?.name, fileType: data?.type, filePath: data?.path },
            ])
            break
        }
      }
      onSuccess(response.data)
      message.success(`上传成功`)
    } catch (error) {
      message.error(`上传失败`)
    }
  }

  const handleRemove = (type: string, index: number) => {
    switch (type) {
      case "ZC":
        setfileZCUrl(fileZCUrl?.filter((v: any, i: number) => i !== index))
        break
      case "ZG":
        setfileZGUrl(fileZGUrl?.filter((v: any, i: number) => i !== index))
        break
      case "YS":
        setfileYSUrl(fileYSUrl?.filter((v: any, i: number) => i !== index))
        break
      case "JG":
        setfileJGUrl(fileJGUrl?.filter((v: any, i: number) => i !== index))
        break
    }
  }

  const renderFooter = () => {
    if (props.editable) {
      return null
    }

    return (
      <>
        <Button onClick={props.onCancel}>取消</Button>
        <Button type="primary" onClick={() => form.submit()}>
          提交
        </Button>
      </>
    )
  }

  const doctorOverlay = (
    <Menu style={{ maxHeight: '300px', overflowY: 'auto' }}>
      {doctorList?.map((p: any) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            setKeyword(p.name)
            form.setFieldsValue({
              ...p,
            })
            setfileZGUrl(p.fileZGUrl)
            setfileZCUrl(p.fileZCUrl)
            setfileYSUrl(p.fileYSUrl)
            setfileJGUrl(p.fileJGUrl)
          }}
        >
          <Space>
            <span>{p.name}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )

  const getDoctorList = () => { 
    axios({
      url: `${props.AXIOS_IP}/filingDoctorInfo/getRecentDoctorList`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
    }).then((res: any) => {
      setDoctorList(res.data.data?.map((v: any) => {
        return {
          ...v,
          workStartDate: moment(v?.workStartDate),
          birthDate: v?.workStartDate
            ? moment(v?.workStartDate)
            : "",
          fileZGUrl: v.professionalQualificationCertificateFileUrl || [],
          fileZCUrl: v.professionalTitleCertificateFileUrl || [],
          fileYSUrl: v.practiceCertificateFileUrl || [],
          fileJGUrl: v.institutionReviewFileUrl || [],
        }
      }))
    })
  }

  const getBase64Url = (v: any) => {
    axios({
      url: `${props.AXIOS_IP}/infra/file/downloadFile/${v.fileConfigId}/${v.filePath}`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "GET",
    }).then((res: any) => {
      setBaseType(v.fileType?.includes("pdf") ? true : false)
      setBaseUrl(`data:${v.fileType};base64,${res.data}`)
      setIsModalVisible(true)
    })
  }

  //身份证号转化生日
  const handleIdCardChange = (e: any) => {
    const idCard = e.target.value;
    if (/(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(idCard)) {
      const birthDate = extractBirthDateFromIdCard(idCard);
      if (birthDate) {
        // 设置出生年月字段的值
        form.setFieldsValue({
          birthDate: birthDate
        });
      }
    }
  }

  const extractBirthDateFromIdCard = (idCard: string): moment.Moment | null => {
    if (!idCard) return null;
    
    let birthDateStr = '';
    
    // 15位身份证：7-12位为出生年月日（YYMMDD）
    if (idCard.length === 15) {
      birthDateStr = '19' + idCard.substring(6, 12); // 19YYMMDD
    } 
    // 18位身份证：7-14位为出生年月日（YYYYMMDD）
    else if (idCard.length === 18) {
      birthDateStr = idCard.substring(6, 14); // YYYYMMDD
    }
    
    if (birthDateStr && birthDateStr.length === 8) {
      // 格式化为 YYYY-MM-DD
      const formattedDate = `${birthDateStr.substring(0, 4)}-${birthDateStr.substring(4, 6)}-${birthDateStr.substring(6, 8)}`;
      return moment(formattedDate);
    }
    
    return null;
  };

  useEffect(() => {
    form.setFieldsValue({
      professionalQualificationCertificateFileUrl: fileZGUrl,
    })
  }, [fileZGUrl])

  useEffect(() => {
    form.setFieldsValue({
      professionalTitleCertificateFileUrl: fileZCUrl,
    })
  }, [fileZCUrl])

  useEffect(() => {
    form.setFieldsValue({
      practiceCertificateFileUrl: fileYSUrl,
    })
  }, [fileYSUrl])

  useEffect(() => {
    form.setFieldsValue({
      institutionReviewFileUrl: fileJGUrl,
    })
  }, [fileJGUrl])

  useEffect(() => {
    if (props.visible) {
      getTypes()
      getDoctorList()
      if (props.updateDoctor?.idCardNumber) {
        setKeyword(props.updateDoctor?.name)
        form.setFieldsValue({
          ...props.updateDoctor,
          workStartDate: moment(props.updateDoctor?.workStartDate),
          birthDate: props.updateDoctor?.workStartDate
            ? moment(props.updateDoctor?.workStartDate)
            : "",
        }),
        setfileZGUrl(props.updateDoctor?.fileZGUrl || [])
        setfileZCUrl(props.updateDoctor?.fileZCUrl || [])
        setfileYSUrl(props.updateDoctor?.fileYSUrl || [])
        setfileJGUrl(props.updateDoctor?.fileJGUrl || [])
      } else {
        form. setFieldsValue({
          institutionOrgName: shortName
        })
      }
    } else {
      setKeyword("")
      form.resetFields()
      setfileZGUrl([])
      setfileZCUrl([])
      setfileYSUrl([])
      setfileJGUrl([])
    }
  }, [props.visible, props.updateDoctor])

  return (
    <>
      <Modal
        title="医生信息编辑"
        width={1200}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        confirmLoading={confirmLoading}
        okText="提交"
        centered
        mask={false}
        maskClosable={false}
        footer={renderFooter()}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              if (!fileZGUrl.length) {
                message.error("请上传资格证")
                return
              }
              if (!fileZCUrl.length) {
                message.error("请上传职称证书")
                return
              }
              if (!fileYSUrl.length) {
                message.error("请上传医师执业证")
                return
              }
              if (!fileJGUrl.length) {
                message.error("请上传机构审查意见")
                return
              }
              setConfirmLoading(true)
              const data = {
                ...vs,
                fileZGUrl,
                fileZCUrl,
                fileYSUrl,
                fileJGUrl,
              }
              props.onOk({
                ...data,
                personnelTypeName: types.personnelType?.find(
                  (v: any) => v.value === vs.personnelType
                )?.label,
              })
              setConfirmLoading(false)
            }}
          >
            <Row
              style={{
                fontWeight: "bold",
                fontSize: "17px",
                paddingLeft: "15px",
              }}
            >
              基本信息
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="name"
                  label="姓名"
                  rules={[{ required: true }]}
                >
                  {/* <Input allowClear disabled={props.editable} /> */}
                  <Dropdown
                      overlay={doctorOverlay}
                      visible={isDoctorOverlayVisible}
                      disabled={props.editable}
                    >
                      <Input
                        allowClear
                        // prefix={
                        //   <SearchOutlined style={{ color: theme.tc3 }} />
                        // }
                        value={keyword}
                        onFocus={() => {
                          // dispatch(getPatientList(keyword))
                          setIsDoctorOverlayVisible(true)
                        }}
                        onBlur={() => {
                          setTimeout(() => {
                            setIsDoctorOverlayVisible(false)
                          }, 300)
                        }}
                        onClick={() => {
                          setIsDoctorOverlayVisible(true)
                        }}
                        onChange={(e) => {
                          form.setFieldsValue({
                            name: e.target.value,
                          })
                          setIsDoctorOverlayVisible(true)
                          setKeyword(e.target.value)
                        }}
                      />
                    </Dropdown>
                </Form.Item>
              </Col>
              <Col span={12}></Col>
              <Col span={12}>
                <Form.Item
                  name="idCardType"
                  label="证件类型"
                  rules={[{ required: true }]}
                >
                  <Select allowClear disabled={props.editable}>
                    {types.idCardType?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="idCardNumber"
                  label="证件号码"
                  rules={[
                    {
                      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                      message: "身份证格式错误",
                    },
                    {
                      max: 18,
                      message: "最长18位!",
                    },
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input allowClear disabled={props.editable} onBlur={handleIdCardChange} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="birthDate" label="出生年月">
                  <DatePicker
                    style={{ width: "100%" }}
                    format={DateTimeFormatSimple}
                    allowClear
                    disabled={props.editable}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="politicalStatus" label="政治面貌">
                  <Select allowClear disabled={props.editable}>
                    {types.politicalStatus?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="education" label="学历">
                  <Select allowClear disabled={props.editable}>
                    {types.educationLevel?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="degree" label="学位">
                  <Select allowClear disabled={props.editable}>
                    {types.degreeType?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="major" label="所学专业">
                  <Input allowClear disabled={props.editable} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="personnelType"
                  label="人员类型"
                  rules={[{ required: true }]}
                >
                  <Select allowClear disabled={props.editable}>
                    {types.personnelType?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="phone"
                  label="手机号码"
                  rules={[
                    {
                      pattern: /^1\d{10}$/,
                      message: "请输入正确的手机号",
                    },
                  ]}
                >
                  <Input allowClear disabled={props.editable} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="institutionOrgName"
                  label="所属机构"
                  rules={[{ required: true }]}
                >
                  <Input allowClear disabled={props.editable} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="department" label="所在科室">
                  <Input allowClear disabled={props.editable} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="officePhone" label="办公室电话">
                  <Input allowClear disabled={props.editable} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="workStatus" label="工作状态">
                  <Select allowClear disabled={props.editable}>
                    {types.workStatus?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  name="introduction"
                  label="医生介绍"
                >
                  <TextArea
                    disabled={props.editable}
                    allowClear
                    showCount
                    maxLength={500}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  name="professionalTitleCertificateFileUrl"
                  label="职称证书"
                  rules={[{ required: true }]}
                >
                  <Row align="middle">
                    {!props.editable && (
                      <>
                        <Upload
                          customRequest={(options) =>
                            customRequest(options, "ZC")
                          }
                          beforeUpload={(file) => beforeUpload(file, fileZCUrl)}
                          showUploadList={false}
                          maxCount={3}
                          accept={acceptImgTypes}
                        >
                          <Button icon={<PlusOutlined />}>上传</Button>
                        </Upload>
                        <span style={{ padding: "0 10px 0 15px" }}>
                          支持jpg、png等图片格式
                        </span>
                      </>
                    )}
                    {fileZCUrl?.length > 0 &&
                      fileZCUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a style={{ paddingLeft: 10 }} onClick={() => getBase64Url(v)}>查看</a>
                            </span>
                            {!props.editable && (
                              <CloseOutlined
                                style={{
                                  position: "relative",
                                  top: 2,
                                  color: "rgb(161 161 161)",
                                }}
                                onClick={() => {
                                  handleRemove("ZC", index)
                                }}
                              />
                            )}
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
            <Row
              style={{
                fontWeight: "bold",
                fontSize: "17px",
                marginBottom: "10px",
                paddingLeft: "15px",
              }}
            >
              执业信息
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="workStartDate"
                  label="参加工作时间"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format={DateTimeFormatSimple}
                    allowClear
                    disabled={props.editable}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="administrativeManagement"
                  label="行政/业务管理"
                  rules={[{ required: true }]}
                >
                  <Select allowClear disabled={props.editable}>
                    {types.administrativeManagement?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="practiceCertificateCode"
                  label="执业证书代码"
                  rules={[{ required: true }]}
                >
                  <Input allowClear disabled={props.editable} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="practiceScope"
                  label="执业范围"
                  rules={[{ required: true }]}
                >
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option: any) => {
                      return (option?.children ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }}
                    disabled={props.editable}
                  >
                    {types.practiceScope?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="practiceCategory"
                  label="执业类别"
                  rules={[{ required: true }]}
                >
                  <Select allowClear disabled={props.editable}>
                    {types.practiceCategory?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="multiSitePractice"
                  label="是否注册为多点执业医师"
                  rules={[{ required: true }]}
                >
                  <Select allowClear disabled={props.editable}>
                    {types.multiSitePractice?.map((v: any) => {
                      return (
                        <Option key={v.value} value={v.value}>
                          {v.label}
                        </Option>
                      )
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="professionalQualificationCertificateFileUrl"
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  label="资格证"
                  rules={[{ required: true }]}
                >
                  <Row align="middle">
                    {!props.editable && (
                      <>
                        <Upload
                          customRequest={(options) =>
                            customRequest(options, "ZG")
                          }
                          beforeUpload={(file) => beforeUpload(file, fileZGUrl)}
                          showUploadList={false}
                          maxCount={3}
                          accept={acceptImgTypes}
                          disabled={props.editable}
                        >
                          <Button icon={<PlusOutlined />}>上传</Button>
                        </Upload>
                        <span style={{ padding: "0 10px 0 15px" }}>
                          支持jpg、png等图片格式
                        </span>
                      </>
                    )}
                    {fileZGUrl?.length > 0 &&
                      fileZGUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a style={{ paddingLeft: 10 }} onClick={() => getBase64Url(v)}>查看</a>
                            </span>
                            {!props.editable && (
                              <CloseOutlined
                                style={{
                                  position: "relative",
                                  top: 2,
                                  color: "rgb(161 161 161)",
                                }}
                                onClick={() => {
                                  handleRemove("ZG", index)
                                }}
                              />
                            )}
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="practiceCertificateFileUrl"
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  label="医师执业证"
                  rules={[{ required: true }]}
                >
                  <Row align="middle">
                    {!props.editable && (
                      <>
                        <Upload
                          customRequest={(options) =>
                            customRequest(options, "YS")
                          }
                          beforeUpload={(file) => beforeUpload(file, fileYSUrl)}
                          showUploadList={false}
                          maxCount={3}
                          accept={acceptImgTypes}
                        >
                          <Button icon={<PlusOutlined />}>上传</Button>
                        </Upload>
                        <span style={{ padding: "0 10px 0 15px" }}>
                          支持jpg、png等图片格式
                        </span>
                      </>
                    )}
                    {fileYSUrl?.length > 0 &&
                      fileYSUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a style={{ paddingLeft: 10 }} onClick={() => getBase64Url(v)}>查看</a>
                            </span>
                            {!props.editable && (
                              <CloseOutlined
                                style={{
                                  position: "relative",
                                  top: 2,
                                  color: "rgb(161 161 161)",
                                }}
                                onClick={() => {
                                  handleRemove("YS", index)
                                }}
                              />
                            )}
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="institutionReviewFileUrl"
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  label="机构审查意见"
                  rules={[{ required: true }]}
                >
                  <Row align="middle">
                    {!props.editable && (
                      <>
                        <Upload
                          customRequest={(options) =>
                            customRequest(options, "JG")
                          }
                          beforeUpload={(file) =>
                            beforeUploadFile(file, fileJGUrl)
                          }
                          showUploadList={false}
                          maxCount={3}
                          accept={".pdf"}
                        >
                          <Button icon={<PlusOutlined />}>上传</Button>
                        </Upload>
                        <span style={{ padding: "0 10px 0 15px" }}>
                          支持pdf等文件格式
                        </span>
                      </>
                    )}
                    {fileJGUrl?.length > 0 &&
                      fileJGUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a style={{ paddingLeft: 10 }} onClick={() => getBase64Url(v)}>查看</a>
                            </span>
                            {!props.editable && (
                              <CloseOutlined
                                style={{
                                  position: "relative",
                                  top: 2,
                                  color: "rgb(161 161 161)",
                                }}
                                onClick={() => {
                                  handleRemove("JG", index)
                                }}
                              />
                            )}
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        title={"预览"}
        visible={isModalVisible}
        footer={null}
        width={"80%"}
        onCancel={() => {
          setIsModalVisible(false)
        }}
      >
        <div style={{ height: "650px" }}>
          {baseType ? (
            <iframe
              title="预览"
              style={{ width: "100%", height: "100%" }}
              src={baseUrl}
            />
          ) : (
            <img
              v-else
              src={baseUrl}
              alt="预览图片"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          )}
        </div>
      </Modal>
    </>
  )
}
